import { render, staticRenderFns } from "./RamsRisks.vue?vue&type=template&id=6ba125fe&"
import script from "./RamsRisks.vue?vue&type=script&lang=js&"
export * from "./RamsRisks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports